import { FC, useCallback } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';

import { useFirebaseAuth } from '../context/FirebaseContextProvider';
import { DashboardRoutePath } from '../modules/dashboard';
import { Splash } from '../shared/Components';
import { RoutePropsExtended } from '../types';

const PublicRoute: FC<RoutePropsExtended> = ({ component: Component, noNavBar, ...rest }) => {
  const user = useFirebaseAuth();
  const renderRoute = useCallback(
    (props: RouteComponentProps) => {
      const RouteComponent = Component as React.ComponentType<RouteComponentProps>;
      const to = {
        pathname: `/${DashboardRoutePath.PUZZLES}`,
        state: {
          from: props.location,
        },
      };

      return user ? <Redirect to={to} /> : <RouteComponent {...props} />;
    },
    [Component, noNavBar, user],
  );

  return user === undefined ? <Splash /> : <Route {...rest} render={renderRoute} />;
};

export default PublicRoute;
